import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL + 'mcqs';

export const getSubjects = async () => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${BASE_URL}/subjects`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching subjects:', error);
    return Promise.reject(error);
  }
};

export const getTopicsAndSubtopics = async (subjectId) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${BASE_URL}/topics-subtopics/${subjectId}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching topics and subtopics:', error);
    return Promise.reject(error);
  }
};

export const getQuestions = async (subjectId, topicId, subtopicId, numberOfQuestions) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${BASE_URL}/questions`, {
      params: {
        subject_id: subjectId,
        topic_id: topicId,
        subtopic_id: subtopicId,
        number_of_questions: numberOfQuestions
      },
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    return Promise.reject(error);
  }
};

export const evaluateAnswers = async (answers) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.post(`${BASE_URL}/evaluate`, {
      answers: answers
    }, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error evaluating answers:', error);
    return Promise.reject(error);
  }
}; 

